module.exports = __webpack_public_path__ + "img/exam_6.a101be96.png";